import React from 'react';
import chine from '../../../assets/images/baccarat/chine.svg';
import chine2 from '../../../assets/images/baccarat/chine-2.svg';
import { BET_TYPES, BET_TYPES_VIEW } from '../../../enums/betTypesEnum';
import MainBets from '../../betTypesComp/mainBets';
import SideBets from '../../betTypesComp/sideBets';
import BetTypeInfo from '../../betTypesComp/betTypeInfo';

function BetTypesWebView({
  quickBets,
  chipByTypes,
  playerCards,
  bankerCards,
  handleDoChip,
  lastBetModel,
  bankerTotalPoints,
  playerTotalPoints,
  selectedCardType,
  isBetsClosed,
  activeFreeBet,
}) {
  return (
    <>
      <SideBets
        name='P'
        betType={BET_TYPES.PLAYER_PAIR}
        viewType={BET_TYPES_VIEW.PLAYER_PAIR}
        handleDoChip={handleDoChip}
        chipByTypes={chipByTypes}
        quickBets={quickBets}
        activeFreeBet={activeFreeBet}
        isBetsClosed={isBetsClosed}
      />
      <MainBets
        name='PLAYER'
        betType={BET_TYPES.PLAYER}
        viewType={BET_TYPES_VIEW.PLAYER}
        handleDoChip={handleDoChip}
        lastBetModel={lastBetModel}
        chipByTypes={chipByTypes}
        quickBets={quickBets}
        activeFreeBet={activeFreeBet}
        isBetsClosed={isBetsClosed}
      >
        <BetTypeInfo
          selectedCardType={selectedCardType}
          totalPoint={playerTotalPoints}
          betType={BET_TYPES.PLAYER}
          cards={playerCards}
          imgSrc={chine2}
        />
      </MainBets>
      <MainBets
        name='TIE'
        betType={BET_TYPES.TIE}
        viewType={BET_TYPES_VIEW.TIE}
        handleDoChip={handleDoChip}
        chipByTypes={chipByTypes}
        quickBets={quickBets}
        activeFreeBet={activeFreeBet}
        isBetsClosed={isBetsClosed}
      />
      <MainBets
        name='BANKER'
        betType={BET_TYPES.BANKER}
        viewType={BET_TYPES_VIEW.BANKER}
        handleDoChip={handleDoChip}
        chipByTypes={chipByTypes}
        quickBets={quickBets}
        activeFreeBet={activeFreeBet}
        isBetsClosed={isBetsClosed}
      >
        <BetTypeInfo
          selectedCardType={selectedCardType}
          totalPoint={bankerTotalPoints}
          cards={bankerCards}
          betType={BET_TYPES.BANKER}
          imgSrc={chine}
        />
      </MainBets>
      <SideBets
        name='B'
        betType={BET_TYPES.BANKER_PAIR}
        viewType={BET_TYPES_VIEW.BANKER_PAIR}
        handleDoChip={handleDoChip}
        chipByTypes={chipByTypes}
        activeFreeBet={activeFreeBet}
        quickBets={quickBets}
        isBetsClosed={isBetsClosed}
      />
    </>
  );
}

export default BetTypesWebView;
